import { render, staticRenderFns } from "./IconSvgPlayCircle.vue?vue&type=template&id=4d1e240a&scoped=true&"
import script from "./IconSvgPlayCircle.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlayCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e240a",
  null
  
)

export default component.exports